import { toURL } from "@prismicio/editor-support/URL"
import { Box, Icon } from "@prismicio/editor-ui"
import type { EmbedContent } from "@prismicio/types-internal/lib/content"
import type { Node as ProseMirrorNode } from "@tiptap/pm/model"
import { type NodeViewProps, NodeViewWrapper } from "@tiptap/react"
import { useRef } from "react"

import { Footer } from "../../../EmbedField/EmbedFooter"
import { FieldTextInput } from "../../../FieldTextInput"
import { useSelected } from "../useSelected"
import { useEmbedView } from "./useEmbedView"

interface EmbedNode extends ProseMirrorNode {
  attrs: { content?: EmbedContent }
}
export interface EmbedViewProps extends NodeViewProps {
  node: EmbedNode
}

export function EmbedView(props: EmbedViewProps) {
  const inputRef = useRef<HTMLInputElement>(null)
  const containerRef = useRef<HTMLDivElement>(null)

  const { onKeyDown, url, urlChanged, onContentChange, debouncedUrl, content } =
    useEmbedView(props, inputRef, containerRef)

  const { selected } = useSelected(props)

  return (
    <NodeViewWrapper className="custom-embed">
      <div contentEditable="false" suppressContentEditableWarning>
        <Box flexGrow={1} alignItems="center">
          <Icon size="small" name="cloud" color="grey11" />
          <Box flexGrow={1} height={40} ref={containerRef}>
            <FieldTextInput
              id="id"
              ref={inputRef}
              value={url}
              variant={toURL(url) ? "link" : "normal"}
              placeholder="Paste your link here"
              onValueChange={urlChanged}
              onKeyDown={onKeyDown}
            />
          </Box>
        </Box>

        {toURL(url) && (
          <Footer
            selected={selected}
            debouncedUrl={debouncedUrl}
            onContentChange={onContentChange}
            content={content}
          />
        )}
      </div>
    </NodeViewWrapper>
  )
}
